var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12,2h-5c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1h5c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16,14H1c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1h15c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19,10H7c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1h12c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15,6H3c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1h12c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18,18H4c-.6,0-1-.4-1-1h0c0-.6.4-1,1-1h14c.6,0,1,.4,1,1h0c0,.6-.5,1-1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.761b6f72541d42d9bc3649b6412e6b97.svg";
export { ForwardRef as ReactComponent };